import {H3} from '@jetbrains/ring-ui/components/heading/heading'
import classNames from 'classnames'

import Pager from '../../../../common/PagerNew/PagerNew'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'

import {usePipelineHistory} from './PipelineHistory.hooks'
import PipelineRunLine from './PipelineRunLine/PipelineRunLine'

import styles from './PipelineHistory.css'

import HelpDetails from 'src/components/common/HelpDetails/HelpDetails'

function Empty() {
  return (
    <>
      <H3>{'There are no runs yet'}</H3>
      <p className={styles.emptyListDescription}>
        {`Try setting up the pipeline by going into Edit mode.
          You can also start it by clicking the Run button.`}
      </p>
    </>
  )
}

type Props = {
  className?: string
  pipelineHeadKey: pipelineHeadFragment$key | null
}

function PipelineHistory({className, pipelineHeadKey}: Props) {
  const {ids, pager} = usePipelineHistory(pipelineHeadKey)

  const renderContent = () => {
    if (ids.length === 0) {
      return <Empty />
    }
    return (
      <div className={styles.wrapper}>
        <div className={styles.runs}>
          <div className={styles.columnHeader}>{'#Run'}</div>
          <div className={styles.columnHeader}>{'Status'}</div>
          <div className={styles.columnHeader}>{'Branch'}</div>
          <div className={styles.columnHeader}>{'Changes'}</div>
          <div className={classNames(styles.columnHeader, styles.startDate)}>{'Start time'}</div>
          <div className={styles.columnHeader}>
            {'Total duration'}
            <HelpDetails acnhorClassName={styles.durationDetails}>
              {'Includes the actual run duration and time spent in queue'}
            </HelpDetails>
          </div>
          <div className={styles.columnUnderline} />
          {ids.map(runId => (
            <div key={runId} className={styles.line}>
              <PipelineRunLine runId={runId} pipelineHeadKey={pipelineHeadKey} />
              <div className={styles.columnUnderline} />
            </div>
          ))}
        </div>
        <Pager {...pager} className={styles.pager} />
      </div>
    )
  }

  return (
    <div className={classNames(className, styles.container, {[styles.empty]: ids.length === 0})}>
      {renderContent()}
    </div>
  )
}

export default PipelineHistory
